// @ts-nocheck
import { capitalize, isEmpty, uniq } from 'lodash';
import { Checkbox, Selector } from 'sonata-react-components';

import { ContentCategoryProvider, DcoDimensionSelector } from '@/ts-modules/reporting/ReportingInsights/CustomFilters';
import { getPaginatedInsightsStats } from '../reporting.resources.legacy';
import BoundaryShape from './CustomFilters/BoundaryShape/BoundaryShape';

export const getComponent = type => {
  switch (type) {
    case 'selector':
      return Selector;
    case 'checkbox':
      return Checkbox;
    case 'boundary-shape':
      return BoundaryShape;
    case 'content-category-provider':
      return ContentCategoryProvider;
    case 'dco-dimension-selector':
      return DcoDimensionSelector;
    default:
      return null;
  }
};

export const getSortConfig = option => {
  const sortParams = option.split('-');
  return {
    metric: sortParams[0],
    order: sortParams[1]
  };
};

export const getFilterConfigValue = (filtersConfig, key, defaultSort) => {
  const config = filtersConfig?.length && filtersConfig?.find(filter => filter.key === key);

  return config ? config.value : defaultSort || {};
};

const getLabel = (item, intl) => {
  let optionLabel = `${intl.formatMessage({ id: item.label })}`;
  if (item.sortOrder) {
    optionLabel += ` - ${intl.formatMessage({
      defaultMessage: item.sortOrder.toUpperCase(),
      id: item.sortOrderLabel
    })}`;
  }

  return optionLabel;
};
export const getCountryFilter = selectedCountry => {
  const countries = Array.isArray(selectedCountry) ? selectedCountry : [selectedCountry];
  return selectedCountry ? { 'cartoPyramid.level0': countries } : {};
};

export const getUpdatedProps = (type, props, intl, insightId) => {
  let options;
  switch (type) {
    case 'selector':
      options = props.options.map(option => ({
        ...option,
        label: getLabel(option, intl)
      }));
      return {
        ...props,
        defaultValue: props.defaultValue.map(item => ({
          ...item,
          label: getLabel(item, intl)
        })),
        label: intl.formatMessage({ id: props.label }),
        options
      };
    case 'checkbox':
      return {
        ...props,
        labelText: intl.formatMessage({ id: props.labelText })
      };
    case 'content-category-provider':
      return {
        ...props,
        insightId
      };
    case 'boundary-shape':
    case 'dco-dimension-selector':
      return {
        ...props,
        insightId,
        label: intl.formatMessage({ id: props.label })
      };
    default:
  }
};

export const getUniqueCountries = campaigns =>
  campaigns.reduce((acc, actualItem) => {
    actualItem.countries.forEach(country => {
      if (acc.includes(country)) {
        return acc;
      }
      acc.push(country);
    });
    return acc;
  }, []);

const getDefaultValue = (metricsKpis, options, defaultOrder) => {
  const { order, type } = defaultOrder;
  return options.filter(option => option.id === `${metricsKpis[type].id}-${order}`);
};

const getOptions = (metricsKpis, hideKpi = false) => {
  const { kpi = { id: 'N/A' }, metric = { id: 'N/A' } } = metricsKpis;
  const { id: kpiId } = kpi;
  const { id: metricId } = metric;
  const metricIds = [];
  !hideKpi && kpiId !== 'N/A' && metricIds.push(kpiId);
  metricId !== 'N/A' && metricIds.push(metricId);
  return metricIds.reduce((optionsAcc, optionId) => {
    optionsAcc.push(
      ...['desc', 'asc'].map(sortOrder => ({
        default: capitalize(optionId),
        id: `${optionId}-${sortOrder}`,
        label: `reporting.metrics.${optionId}`,
        sortOrder,
        sortOrderLabel: `reporting.insights.filters.selectors.sorting.suffix.${sortOrder}`
      }))
    );
    return optionsAcc;
  }, []);
};

export const formatFilters = (metricsKpis, countries, filters, hideKpi = false) => {
  return filters.map(filterEntry => {
    if (filterEntry.id === 'order') {
      const options = getOptions(metricsKpis, hideKpi);
      return {
        ...filterEntry,
        props: {
          ...filterEntry.props,
          defaultValue: filterEntry.props.defaultOrder
            ? getDefaultValue(metricsKpis, options, filterEntry.props.defaultOrder)
            : [options[0]],
          options
        }
      };
    }
    if (filterEntry.id === 'boundary') {
      return {
        ...filterEntry,
        props: {
          ...filterEntry.props,
          countries,
          defaultLevel: countries.length > 1 ? 'level0' : filterEntry.props.defaultLevel
        }
      };
    }
    return filterEntry;
  });
};

export const checkIfDOOHAudienceStatsExists = async (
  campaignInfo,
  insightsConfig,
  metric,
  selectedCountry,
  variableType,
  variableValues,
  token
) => {
  const { cIds, cartographyFilter, dateInterval, userId } = campaignInfo;
  const demographicAgeConfig = insightsConfig
    .find(({ type }) => {
      return type === 'audience';
    })
    .items?.find(({ field }) => {
      return field === 'demographicAge';
    });
  const filterGroupOptions = getFilterConfigValue(demographicAgeConfig, 'groupOptions');
  const { filterOptions, groupsOptions: groupsOptionsByConfig } = demographicAgeConfig || {};
  const groupOptions = isEmpty(filterGroupOptions) ? groupsOptionsByConfig : filterGroupOptions;
  const sortOptions = {
    metric: 'impressions',
    order: 'desc'
  };
  const variableFilter = variableValues.length ? { [variableType]: variableValues } : {};
  const countryFilter = getCountryFilter(selectedCountry);
  const {
    metadata: { totalResults },
    results
  } = await getPaginatedInsightsStats(
    userId,
    cIds,
    dateInterval,
    cartographyFilter,
    null,
    metric,
    groupOptions,
    sortOptions,
    undefined,
    {
      ...filterOptions,
      ...variableFilter,
      ...countryFilter
    },
    false,
    token
  );
  return {
    exists: uniq(results.map(result => result[metric])).length === results.length && results.length > 1,
    total: totalResults[metric]
  };
};
